import React from 'react';

export const CustomLoading = ({ color }) => {
    return (
        <>
            <div className='container-fluid bd-example-row'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <div className='loader'>
                            <div className={`line bg-${color ? color : 'primary'}`}></div>
                            <div className={`line bg-${color ? color : 'primary'}`}></div>
                            <div className={`line bg-${color ? color : 'primary'}`}></div>
                            <div className={`line bg-${color ? color : 'primary'}`}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
